'use client';
import JumpIcon from '@/assets/icons/all-icon.svg';
import NewUserGift from '@/assets/icons/newuserGift.svg';
import { useRouter } from 'next/navigation';
import style from './style.module.scss';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';

export default function Module({ moduleData }: { moduleData: any }) {
  const external = moduleData?.externalData;
  const richText = external?.data && external?.data?.richTextNew;
  const router = useRouter();
  return (
    <div
      className={style['uk-h5-newcomer-gift']}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      data-exp={JSON.stringify({
        spm: 'a0145.b002218.c00002484.Short',
        page_id: 'Home_Main',
        event_id: 'Home_Welcome_Short_Expo',
      })}
    >
      <div
        className={style.container}
        onClick={(e) => {
          spmTrackingUtils.spmClick({
            spm: 'a0145.b002218.c00002484.Short',
            page_id: 'Home_Main',
            event_id: 'Home_Welcome_Short',
            target: e.target as HTMLElement,
          });
          router.push('/promo/welcome-discounts');
        }}
      >
        <div className={style.icon}>
          <NewUserGift width='32' height='32' />
        </div>

        <div className={style.richText} dangerouslySetInnerHTML={{ __html: richText }} />
        <div className={style.jumpIcon}>
          <JumpIcon />
        </div>
      </div>
    </div>
  );
}
